/* eslint-disable */
import type * as Types from '../../../../../graphql/gql-types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetAITracesQueryVariables = Types.Exact<{
  filter?: Types.InputMaybe<Types.AITracesFilter>;
}>;


export type GetAITracesQuery = { __typename?: 'Query', getAITraces?: Array<{ __typename?: 'AITrace', id?: string | undefined, sessionId?: string | undefined, userId?: string | undefined, functionId?: string | undefined, requestId?: string | undefined, parentSpanId?: string | undefined, modelName?: string | undefined, environment?: string | undefined, systemPrompt?: string | undefined, inputMessages?: string | undefined, outputContent?: string | undefined, inputTokens?: number | undefined, outputTokens?: number | undefined, totalTokens?: number | undefined, totalCost?: string | undefined, latencyMs?: number | undefined, status?: string | undefined, errorMessage?: string | undefined, metadata?: string | undefined, createdAt?: string | undefined, session?: { __typename?: 'AISession', id?: string | undefined, userId?: string | undefined, environment?: string | undefined, metadata?: string | undefined, startTime?: string | undefined, endTime?: string | undefined, totalTokens?: number | undefined, totalCost?: string | undefined } | undefined } | undefined> | undefined };

export type GetAITraceQueryVariables = Types.Exact<{
  id: Types.Scalars['ID'];
}>;


export type GetAITraceQuery = { __typename?: 'Query', getAITrace?: { __typename?: 'AITrace', id?: string | undefined, sessionId?: string | undefined, userId?: string | undefined, functionId?: string | undefined, requestId?: string | undefined, parentSpanId?: string | undefined, modelName?: string | undefined, environment?: string | undefined, systemPrompt?: string | undefined, inputMessages?: string | undefined, outputContent?: string | undefined, inputTokens?: number | undefined, outputTokens?: number | undefined, totalTokens?: number | undefined, totalCost?: string | undefined, latencyMs?: number | undefined, status?: string | undefined, errorMessage?: string | undefined, metadata?: string | undefined, createdAt?: string | undefined, session?: { __typename?: 'AISession', id?: string | undefined, userId?: string | undefined, environment?: string | undefined, metadata?: string | undefined, startTime?: string | undefined, endTime?: string | undefined, totalTokens?: number | undefined, totalCost?: string | undefined } | undefined } | undefined };

export type GetAIEvaluationsQueryVariables = Types.Exact<{
  filter?: Types.InputMaybe<Types.AIEvaluationsFilter>;
}>;


export type GetAIEvaluationsQuery = { __typename?: 'Query', getAIEvaluations?: Array<{ __typename?: 'AIEvaluation', id?: string | undefined, traceId?: string | undefined, categoryId?: string | undefined, evaluatorModel?: string | undefined, evaluationPrompt?: string | undefined, evaluationOutput?: string | undefined, scores?: string | undefined, inputTokens?: number | undefined, outputTokens?: number | undefined, totalTokens?: number | undefined, latencyMs?: number | undefined, status?: string | undefined, errorMessage?: string | undefined, metadata?: string | undefined, createdAt?: string | undefined, category?: { __typename?: 'AIEvaluationCategory', id?: string | undefined, name?: string | undefined, description?: string | undefined, scoringCriteria?: string | undefined, isActive?: boolean | undefined, createdAt?: string | undefined } | undefined, trace?: { __typename?: 'AITrace', id?: string | undefined, sessionId?: string | undefined, userId?: string | undefined, functionId?: string | undefined, requestId?: string | undefined, parentSpanId?: string | undefined, modelName?: string | undefined, environment?: string | undefined, systemPrompt?: string | undefined, inputMessages?: string | undefined, outputContent?: string | undefined, inputTokens?: number | undefined, outputTokens?: number | undefined, totalTokens?: number | undefined, totalCost?: string | undefined, latencyMs?: number | undefined, status?: string | undefined, errorMessage?: string | undefined, metadata?: string | undefined, createdAt?: string | undefined } | undefined } | undefined> | undefined };

export type GetAIEvaluationCategoriesQueryVariables = Types.Exact<{
  activeOnly?: Types.InputMaybe<Types.Scalars['Boolean']>;
}>;


export type GetAIEvaluationCategoriesQuery = { __typename?: 'Query', getAIEvaluationCategories?: Array<{ __typename?: 'AIEvaluationCategory', id?: string | undefined, name?: string | undefined, description?: string | undefined, scoringCriteria?: string | undefined, isActive?: boolean | undefined, createdAt?: string | undefined } | undefined> | undefined };

export type GetAITracesStatsQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type GetAITracesStatsQuery = { __typename?: 'Query', getAITracesStats?: { __typename?: 'AITracesStats', totalTraces?: number | undefined, totalSessions?: number | undefined, totalCost?: string | undefined, avgLatencyMs?: number | undefined, successRate?: number | undefined, topModels?: Array<{ __typename?: 'ModelUsageStats', modelName?: string | undefined, traceCount?: number | undefined, totalCost?: string | undefined, avgLatencyMs?: number | undefined } | undefined> | undefined } | undefined };


export const GetAITracesDocument = gql`
    query GetAITraces($filter: AITracesFilter) {
  getAITraces(filter: $filter) {
    id
    sessionId
    userId
    functionId
    requestId
    parentSpanId
    modelName
    environment
    systemPrompt
    inputMessages
    outputContent
    inputTokens
    outputTokens
    totalTokens
    totalCost
    latencyMs
    status
    errorMessage
    metadata
    createdAt
    session {
      id
      userId
      environment
      metadata
      startTime
      endTime
      totalTokens
      totalCost
    }
  }
}
    `;

/**
 * __useGetAITracesQuery__
 *
 * To run a query within a React component, call `useGetAITracesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAITracesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAITracesQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useGetAITracesQuery(baseOptions?: Apollo.QueryHookOptions<GetAITracesQuery, GetAITracesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAITracesQuery, GetAITracesQueryVariables>(GetAITracesDocument, options);
      }
export function useGetAITracesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAITracesQuery, GetAITracesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAITracesQuery, GetAITracesQueryVariables>(GetAITracesDocument, options);
        }
export type GetAITracesQueryHookResult = ReturnType<typeof useGetAITracesQuery>;
export type GetAITracesLazyQueryHookResult = ReturnType<typeof useGetAITracesLazyQuery>;
export type GetAITracesQueryResult = Apollo.QueryResult<GetAITracesQuery, GetAITracesQueryVariables>;
export const GetAITraceDocument = gql`
    query GetAITrace($id: ID!) {
  getAITrace(id: $id) {
    id
    sessionId
    userId
    functionId
    requestId
    parentSpanId
    modelName
    environment
    systemPrompt
    inputMessages
    outputContent
    inputTokens
    outputTokens
    totalTokens
    totalCost
    latencyMs
    status
    errorMessage
    metadata
    createdAt
    session {
      id
      userId
      environment
      metadata
      startTime
      endTime
      totalTokens
      totalCost
    }
  }
}
    `;

/**
 * __useGetAITraceQuery__
 *
 * To run a query within a React component, call `useGetAITraceQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAITraceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAITraceQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetAITraceQuery(baseOptions: Apollo.QueryHookOptions<GetAITraceQuery, GetAITraceQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAITraceQuery, GetAITraceQueryVariables>(GetAITraceDocument, options);
      }
export function useGetAITraceLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAITraceQuery, GetAITraceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAITraceQuery, GetAITraceQueryVariables>(GetAITraceDocument, options);
        }
export type GetAITraceQueryHookResult = ReturnType<typeof useGetAITraceQuery>;
export type GetAITraceLazyQueryHookResult = ReturnType<typeof useGetAITraceLazyQuery>;
export type GetAITraceQueryResult = Apollo.QueryResult<GetAITraceQuery, GetAITraceQueryVariables>;
export const GetAIEvaluationsDocument = gql`
    query GetAIEvaluations($filter: AIEvaluationsFilter) {
  getAIEvaluations(filter: $filter) {
    id
    traceId
    categoryId
    evaluatorModel
    evaluationPrompt
    evaluationOutput
    scores
    inputTokens
    outputTokens
    totalTokens
    latencyMs
    status
    errorMessage
    metadata
    createdAt
    category {
      id
      name
      description
      scoringCriteria
      isActive
      createdAt
    }
    trace {
      id
      sessionId
      userId
      functionId
      requestId
      parentSpanId
      modelName
      environment
      systemPrompt
      inputMessages
      outputContent
      inputTokens
      outputTokens
      totalTokens
      totalCost
      latencyMs
      status
      errorMessage
      metadata
      createdAt
    }
  }
}
    `;

/**
 * __useGetAIEvaluationsQuery__
 *
 * To run a query within a React component, call `useGetAIEvaluationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAIEvaluationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAIEvaluationsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useGetAIEvaluationsQuery(baseOptions?: Apollo.QueryHookOptions<GetAIEvaluationsQuery, GetAIEvaluationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAIEvaluationsQuery, GetAIEvaluationsQueryVariables>(GetAIEvaluationsDocument, options);
      }
export function useGetAIEvaluationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAIEvaluationsQuery, GetAIEvaluationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAIEvaluationsQuery, GetAIEvaluationsQueryVariables>(GetAIEvaluationsDocument, options);
        }
export type GetAIEvaluationsQueryHookResult = ReturnType<typeof useGetAIEvaluationsQuery>;
export type GetAIEvaluationsLazyQueryHookResult = ReturnType<typeof useGetAIEvaluationsLazyQuery>;
export type GetAIEvaluationsQueryResult = Apollo.QueryResult<GetAIEvaluationsQuery, GetAIEvaluationsQueryVariables>;
export const GetAIEvaluationCategoriesDocument = gql`
    query GetAIEvaluationCategories($activeOnly: Boolean) {
  getAIEvaluationCategories(activeOnly: $activeOnly) {
    id
    name
    description
    scoringCriteria
    isActive
    createdAt
  }
}
    `;

/**
 * __useGetAIEvaluationCategoriesQuery__
 *
 * To run a query within a React component, call `useGetAIEvaluationCategoriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAIEvaluationCategoriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAIEvaluationCategoriesQuery({
 *   variables: {
 *      activeOnly: // value for 'activeOnly'
 *   },
 * });
 */
export function useGetAIEvaluationCategoriesQuery(baseOptions?: Apollo.QueryHookOptions<GetAIEvaluationCategoriesQuery, GetAIEvaluationCategoriesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAIEvaluationCategoriesQuery, GetAIEvaluationCategoriesQueryVariables>(GetAIEvaluationCategoriesDocument, options);
      }
export function useGetAIEvaluationCategoriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAIEvaluationCategoriesQuery, GetAIEvaluationCategoriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAIEvaluationCategoriesQuery, GetAIEvaluationCategoriesQueryVariables>(GetAIEvaluationCategoriesDocument, options);
        }
export type GetAIEvaluationCategoriesQueryHookResult = ReturnType<typeof useGetAIEvaluationCategoriesQuery>;
export type GetAIEvaluationCategoriesLazyQueryHookResult = ReturnType<typeof useGetAIEvaluationCategoriesLazyQuery>;
export type GetAIEvaluationCategoriesQueryResult = Apollo.QueryResult<GetAIEvaluationCategoriesQuery, GetAIEvaluationCategoriesQueryVariables>;
export const GetAITracesStatsDocument = gql`
    query GetAITracesStats {
  getAITracesStats {
    totalTraces
    totalSessions
    totalCost
    avgLatencyMs
    successRate
    topModels {
      modelName
      traceCount
      totalCost
      avgLatencyMs
    }
  }
}
    `;

/**
 * __useGetAITracesStatsQuery__
 *
 * To run a query within a React component, call `useGetAITracesStatsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAITracesStatsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAITracesStatsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAITracesStatsQuery(baseOptions?: Apollo.QueryHookOptions<GetAITracesStatsQuery, GetAITracesStatsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAITracesStatsQuery, GetAITracesStatsQueryVariables>(GetAITracesStatsDocument, options);
      }
export function useGetAITracesStatsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAITracesStatsQuery, GetAITracesStatsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAITracesStatsQuery, GetAITracesStatsQueryVariables>(GetAITracesStatsDocument, options);
        }
export type GetAITracesStatsQueryHookResult = ReturnType<typeof useGetAITracesStatsQuery>;
export type GetAITracesStatsLazyQueryHookResult = ReturnType<typeof useGetAITracesStatsLazyQuery>;
export type GetAITracesStatsQueryResult = Apollo.QueryResult<GetAITracesStatsQuery, GetAITracesStatsQueryVariables>;
export const namedOperations = {
  Query: {
    GetAITraces: 'GetAITraces',
    GetAITrace: 'GetAITrace',
    GetAIEvaluations: 'GetAIEvaluations',
    GetAIEvaluationCategories: 'GetAIEvaluationCategories',
    GetAITracesStats: 'GetAITracesStats'
  }
}